import React, { Component } from 'react'
import { Row, Col, Button } from 'reactstrap';
import NurseWidget from './NurseWidget';
import axios from 'axios';
import * as API_LINKS from '../../redux/config/links'
import {toast} from 'react-toastify';

var timer;

class Nurse extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            nurseroomlist: [],
            isLoading: false,
         };
    }

    componentDidMount() {
        this.fetchRoomList()
        timer = setInterval(() => {
            this.fetchRoomList()
        }, 5000);
    }

    componentWillUnmount() {
        clearInterval(timer);
    }

    fetchRoomList = () => {
        var self = this;
        this.setState({
            isLoading: true
        })
        axios({
            method: 'post',
            url: API_LINKS.NURSE_ROOM_LIST_URL,
        })
        .then((response) => {
            self.setState({
                nurseroomlist: response.data.result,
                isLoading: false
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error(error.response.error.message);
                } else if (error.response.status === 403) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error(error.response.error.message);
                } else if (error.response.status === 400) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error(error.response.error.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // console.log(error.request);
                self.setState({
                    isLoading: false
                })
                return toast.error('Request error! Please try again later...')
            } else {
                // Something happened in setting up the request that triggered an Error
                self.setState({
                    isLoading: false
                })
                return toast.error('Something went wrong... Please try again later...')
                // return toast.error(error.message);
            }
        })
    }

    checkStatus = (_status) => {
        if(_status === 1) {
            return "danger"
        } else {
            return "info"
        }
    }

    render() {
        return (
            <div className="animated fadeIn">
                <br/><h2>Automa x RS Hasan Sadikin POC</h2><Button onClick={() => this.fetchRoomList()} disabled={this.state.isLoading}>Refresh</Button><br/><hr/><br/>
                <Row>
                {
                    this.state.isLoading ? 
                    this.state.nurseroomlist.map(data => (
                        <Col md={4} xs={6}>
                            <NurseWidget icon="icon-speedometer" color={this.checkStatus(data.status)} invert room={data.room} bed={data.bed} id={data.id} status={data.status} code={data.code} key={data.id} updateData={this.fetchRoomList}/>
                        </Col>
                    ))
                     : 
                    this.state.nurseroomlist.map(data => (
                        <Col md={4} xs={6}>
                            <NurseWidget icon="icon-speedometer" color={this.checkStatus(data.status)} invert room={data.room} bed={data.bed} id={data.id} status={data.status} code={data.code} key={data.id} updateData={this.fetchRoomList}/>
                        </Col>
                    ))
                }
                </Row>
                {/* <NurseWidget  icon="icon-speedometer" color="danger" invert room={'Room A'} bed={'Bed 1'} id={1} status={1} /> */}
            </div>
        );
    }
}

export default Nurse;


// WEBPACK FOOTER //
// ./src/views/Nurse/Nurse.jsx